import React, { Component } from 'react'
import { Button } from '@winnin/winnin_ui.components.button'
import { Icon } from '@winnin/winnin_ui.components.icon'
import { Title } from '@winnin/winnin_ui.components.title'
import { WithLegend } from '@winnin/winnin_ui.components.with-legend'

import { COLORS } from 'consts'
import { T } from 'lib/tolgee'
import { Filters, TOLGEE_GLOBALS } from 'utils'
import './index.scss'

class SelectGendersButtons extends Component {
  defaultOption = Filters.getDefaultFilter({
    group: 'audienceFilters',
    filter: 'audienceGenders',
  })

  isFilterSelected = option => {
    const { filter, audienceFilterProp } = this.props
    if (filter.value === this.defaultOption.value && !audienceFilterProp) return true
    return option.value === filter.value
  }

  change = option => {
    const { setFilter } = this.props
    const isSameFilter = this.isFilterSelected(option)
    const isDefaultSelected = this.isFilterSelected(this.defaultOption)
    const female = Filters.get('audienceFilters', 'audienceGenders')[1]
    const male = Filters.get('audienceFilters', 'audienceGenders')[2]
    const isMaleSelected = option.value === 'm'

    if (isDefaultSelected) {
      if (isMaleSelected) {
        return setFilter(female)
      }
      return setFilter(male)
    }

    if (isSameFilter) {
      return
    }

    return setFilter(this.defaultOption)
  }

  changeAudienceFilterProp = option => {
    const { setFilter } = this.props
    const isSameFilter = this.isFilterSelected(option)

    if (isSameFilter) {
      return
    }

    return setFilter(option)
  }

  render() {
    const options = Filters.get('audienceFilters', 'audienceGenders')
    const { audienceFilterProp } = this.props

    return (
      <>
        <Title tag="h4" weight="regular" className="audience-options-item-label">
          <T keyName={TOLGEE_GLOBALS.genders.key}>{TOLGEE_GLOBALS.genders.defaultValue}</T>
        </Title>
        <div>
          {options.map(option => {
            // prevents audienceGenders filter "All" option from rendering:
            if (!option.value && !audienceFilterProp) return null

            const active = this.isFilterSelected(option)
            const iconFill = active ? COLORS.base_color2 : COLORS.primary
            const styleProps = active ? { variation: 'primary' } : { variation: 'primary', appearance: 'outline' }
            const stylePropsAudienceFilter = active
              ? { variation: 'primary' }
              : { variation: 'faded', appearance: 'outline' }
            return !audienceFilterProp ? (
              <WithLegend label={option.label} active={active} key={option.label}>
                <Button onClick={() => this.change(option)} {...styleProps}>
                  <Icon icon={option.icon} fill={iconFill} />
                </Button>
              </WithLegend>
            ) : (
              <Button
                className="AudienceFilterDropdownContent-filter-btn"
                key={option.label}
                onClick={() => {
                  !audienceFilterProp ? this.change(option) : this.changeAudienceFilterProp(option)
                }}
                {...stylePropsAudienceFilter}
              >
                <T keyName={option.tolgee.key}>{option.tolgee.defaultValue}</T>
              </Button>
            )
          })}
        </div>
      </>
    )
  }
}

SelectGendersButtons.propTypes = {}

SelectGendersButtons.defaultProps = {
  type: 'checkbox',
  buttonType: 'text',
  allLogic: false,
  audienceFilterProp: false,
}

SelectGendersButtons.displayName = 'SelectGendersButtons'

export default SelectGendersButtons
